import { render } from "./menuadministration.vue?vue&type=template&id=5f3ddf06&scoped=true&ts=true"
import script from "./menuadministration.vue?vue&type=script&lang=ts"
export * from "./menuadministration.vue?vue&type=script&lang=ts"

import "./menuadministration.vue?vue&type=style&index=0&id=5f3ddf06&lang=scss&scoped=true"

import exportComponent from "D:\\code\\GWSD\\ttnewadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f3ddf06"]])

export default __exports__